<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-purple" sprite="receptionist" />
          Virtual Receptionists
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-purple" sprite="receptionist" />
            Virtual Receptionists
          </h1>
        </el-col>
        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>
      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable />
          <el-button
            class="ml-10 hidden-xs-only"
            @click="doExport"
          >
            Export
          </el-button>
        </div>
        <div class="box right">
          <el-button @click="openCreateModal">Add New</el-button>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <edit-form
      :editVisible="editVisible"
      :editProcessing="editProcessing"
      :clearFormFields="clearFormFields"
      :reRenderKey="reRenderKey"
      :selectedIvr="selectedIvr"
      :draggableDestTypes="draggableDestTypes"
      :numberOptions="numberOptions"
      :branchOptions="branchOptions"
      @remoteMethodForAvailableNums="remoteMethodForAvailableNums"
      @cancelOperation="cancelOperation"
      @editOperation="editOperation"
    />

    <create-form
      :draggableDestTypes="draggableDestTypes"
      :reRenderKey="reRenderKey"
      :createVisible="createVisible"
      :createProcessing="createProcessing"
      :clearFormFields="clearFormFields"
      :branchOptions="branchOptions"
      @remoteMethodForAvailableNums="remoteMethodForAvailableNums"
      @cancelOperation="cancelOperation"
      @createOperation="createOperation"
    />
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapActions } from "vuex";
import feathersClient, { apiV2Host } from "../../../feathers/feathers-client";
import CreateForm from "./components/createForm";
import EditForm from "./components/editForm";
import { globalEventBus } from "../../../globalEventBus";
import {ExportToCsv} from "export-to-csv";

export default {
  name: "IVRSTable",
  components: { CreateForm, EditForm },
  data() {
    return {
      reRenderKey: "",
      createProcessing: false,
      editProcessing: false,
      deleteProcessing: false,
      tableData: [],
      allIVRS: [],
      tableLoading: false,
      search: "",
      visibleActionsId: "",
      editIvrId: "",
      editVisible: false,
      createVisible: false,
      selectedIvr: null,
      queryForAvailableNums: "",
      numberOptions: [],
      clearFormFields: false,
      total: 0,
      ivrChannel: null,
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-purple" sprite="receptionist" />
                </div>
              ];
            }
          }
        },
        {
          field: "name",
          title: "Name",
          minWidth: 150,
          sortable: true
        },
        {
          field: "allowDisa",
          title: "Extension Dialing",
          minWidth: 150,
          sortable: true,
          slots: {
            default: ({ row }) => {
              return [<span>{row.allowDisa === "on" ? "yes" : "no"}</span>];
            }
          }
        },
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={"edit-" + row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row.id)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={"delete-" + row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row.id)}
                    class="table-action-button icon-red"
                  />
                </div>
              ];
            }
          }
        }
      ],
      draggableDestTypes: [
        "SPECIAL",
        "CUSTOM",
        "IVR",
        "VOICEMAIL",
        "PLAYBACK",
        "HUNTLIST",
        "EXT",
        "QUEUE",
        "SMS",
        "MUSICONHOLD",
        "CONDITION",
        "MEETME",
      ],
      branchOptions: [],
    };
  },
  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },

  watch: {
    selectedTenant() {
      this.findIvrs();
      this.queryBranches();
      feathersClient
        .service("channel-memberships")
        .remove(null, { query: { channelName: this.ivrChannel } });
      this.joinSocketChannel();
    },
    user() {
      this.findIvrs();
      if (!this.ivrChannel) {
        this.joinSocketChannel();
      }
    },
    search: debounce(function() {
      this.searchIvrs();
    }, 500)
  },
  methods: {

    doExport(){
      const data = [...this.tableData];
      if(data.length){

        const writeData = data.map(item => ({
          name: item.name,
          extensionDialing: item.allowDisa === "on" ? "yes" : "no",
        }));

        const options = {
          filename: 'virtual_receptionists',
          showLabels: true,
          headers: ['Name', 'Extension Dialing']
        }

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },

    formatter(row, column) {
      return row.address;
    },

    remoteMethodForAvailableNums(query) {
      this.queryForAvailableNums = query;
    },

    searchIvrs() {
      if (this.search.length) {
        this.tableData = this.allIVRS.filter(data =>
          data.name.toLowerCase().includes(this.search.toLowerCase())
        );
      } else {
        this.tableData = [...this.allIVRS];
      }
    },

    //General Form and Table Operations

    cellClicked(data) {
      if (data.column.property !== "actions") {
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    deleteOperation(id) {
      this.$confirm("Delete virtual receptionist?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.deleteProcessing = true;

          feathersClient.service('ivrs').remove(id)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success"
              });
              this.deleteProcessing = false;
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.deleteProcessing = false;
            });
        })
        .catch(() => true);
    },

    openCreateModal() {
      this.clearFormFields = false;
      this.createVisible = true;
    },

    openEditModal(id) {
      this.clearFormFields = false;
      this.editIvrId = id;
      feathersClient
        .service("ivrs")
        .get(id)
        .then(res => {
          this.selectedIvr = res;
          if (this.selectedIvr.phoneNums && this.selectedIvr.phoneNums.length) {
            this.numberOptions = [];
            this.selectedIvr.phoneNums.forEach(num => {
              this.numberOptions.push({
                key: num.id,
                label: num.number,
                disabled: false
              });
            });
          }
          this.editVisible = true;
        });
    },

    cancelOperation(type) {
      this.clearFormFields = true;
      this.createVisible = false;
      this.editVisible = false;
      this.selectedIvr = null;
      this.changeReRenderKey();
    },

    createOperation(createData) {
      const createBody = {
        ...createData,
        tenantId: this.selectedTenant.id
      };
      const announcementsIds = createData.announcementsIds.filter(Boolean);
      delete createBody.announcementsIds;

      this.$confirm("Create virtual receptionist?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.createProcessing = true;
          feathersClient.service('ivrs').create(createBody)
            .then((data) => {
              this.$notify({
                title: "Success",
                message: "Created successfully!",
                type: "success"
              });
              this.changeReRenderKey();
              this.createProcessing = false;
              this.clearFormFields = true;
              this.cancelOperation("create");

              // Handle Announcements in V2
              if (announcementsIds.length) {
                fetch(`${apiV2Host}/admin/virtual-receptionist/${data.id}`, {
                  method: "PATCH",
                  headers: {
                    Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ announcementsIds })
                }).then(() => {
                }).catch(error => {
                  this.$notify({
                    title: error.name,
                    message: error.message,
                    type: "error"
                  });
                })
              }
            })
            .catch(error => {
              this.clearFormFields = false;
              this.createProcessing = false;
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
            });
        })
        .catch(() => true);
    },

    editOperation(editData) {
      const editBody = { ...editData, tenantId: this.selectedTenant.id };
      const announcementsIds = editData.announcementsIds.filter(Boolean);
      console.log(announcementsIds);
      delete editBody.announcementsIds;

      this.$confirm("Edit virtual receptionist?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.editProcessing = true;

          feathersClient.service('ivrs').patch(this.editIvrId, editBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Edited successfully!",
                type: "success"
              });
              this.changeReRenderKey();
              this.editProcessing = false;
              this.clearFormFields = true;
              this.cancelOperation("edit");

              // Handle Announcements in V2
              if (announcementsIds) {
                fetch(`${apiV2Host}/admin/virtual-receptionist/${this.editIvrId}`, {
                  method: "PATCH",
                  headers: {
                    Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ announcementsIds })
                }).then(() => {
                }).catch(error => {
                  this.$notify({
                    title: error.name,
                    message: error.message,
                    type: "error"
                  });
                })
              }
            })
            .catch(error => {
              this.clearFormFields = false;
              this.editProcessing = false;
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
            });
        })
        .catch(() => true);
    },

    generateRandomKey() {
      const generateRandomString = () =>
        Math.random()
          .toString(36)
          .slice(2);
      return `${generateRandomString()}-${generateRandomString()}$${generateRandomString()}`;
    },

    changeReRenderKey() {
      this.reRenderKey = this.generateRandomKey();
    },

    findIvrs() {
      this.tableLoading = true;
      this.tableData = [];
      feathersClient
        .service("ivrs")
        .find({
          query: {
            tenantId: this.selectedTenant.id
          }
        })
        .then(res => {
          this.tableData = [...res];
          this.allIVRS = [...res];
          this.total = res.length;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

    joinSocketChannel() {
      const channelService = feathersClient.service("channel-memberships");
      const data = {
        roomType: "admins",
        tenantId: this.selectedTenant.id
      };
      channelService.create(data).then(res => {
        this.ivrChannel = `${data.roomType}/${data.tenantId}`;
      });
    },

    removeListeners() {
      feathersClient.service("ivrs").removeListener("patched");
      feathersClient.service("ivrs").removeListener("created");
      feathersClient.service("ivrs").removeListener("removed");
      globalEventBus.$off("appReconnected");
    },

    queryBranches() {
      feathersClient
        .service("branches")
        .find({
          query: {
            tenantId: this.selectedTenant.id,
            $sort: {
              name: 1,
            },
          },
        })
        .then((res) => {
          this.branchOptions = [...res];
        }).catch(() => {
          this.branchOptions = [];
      });
    },
  },
  created() {
    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on("appReconnected", () => {
      this.joinSocketChannel();
    });

    //record was edited
    //always refresh did destination options
    feathersClient.service("ivrs").on("patched", data => {
      const updateIndex = this.tableData.findIndex(item => item.id === data.id);
      const updateAllIndex = this.allIVRS.findIndex(
        item => item.id === data.id
      );
      if (updateIndex >= 0) {
        this.tableData.splice(updateIndex, 1, data);
      }
      if (updateAllIndex >= 0) {
        this.allIVRS.splice(updateAllIndex, 1, data);
      }
    });

    //record was created
    feathersClient.service("ivrs").on("created", data => {
      this.tableData.push(data);
      this.allIVRS.push(data);
    });

    //record was deleted
    feathersClient.service("ivrs").on("removed", data => {
      const indexToRemove = this.tableData.findIndex(
        item => item.id === data.id
      );
      const indexAllToRemove = this.allIVRS.findIndex(
        item => item.id === data.id
      );
      if (indexToRemove >= 0) {
        this.tableData.splice(indexToRemove, 1);
      }
      if (indexAllToRemove >= 0) {
        this.allIVRS.splice(indexAllToRemove, 1);
      }
    });
  },

  beforeDestroy() {
    this.removeListeners();
    feathersClient
      .service("channel-memberships")
      .remove(null, { query: { channelName: this.ivrChannel } });
  },

  mounted() {
    this.changeReRenderKey();
    if (this.user) {
      this.joinSocketChannel();
      this.findIvrs();
      this.queryBranches();
    }
  }
};
</script>
